import { makeObservable, observable, action } from 'mobx';

class ConsentDialogStore {
  isOpen: boolean = false;

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      open: action,
      close: action
    });
  }

  open = () => {
    this.isOpen = true;
  };

  close = () => {
    this.isOpen = false;
  };
}

const singleton = new ConsentDialogStore();
export default singleton;
